export default "__VITE_ASSET__Dfs9w58E__"